import { createFileRoute, redirect } from '@tanstack/react-router'
import { homeHref } from '@/features/home'

/** Home (Frontend §5.3 row 4). */
export const Route = createFileRoute('/_authed/')({
  beforeLoad: ({ context }) => {
    redirect({ href: homeHref(context.me), replace: true, throw: true })
  },
})
